const SUPABASE_URL = 'https://dqerhchmeqlaueduiacl.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_kE5OXb5EOFqxe9JzyWKMKw_U3k-GJcU';
const PICKS_TABLE = 'oscars_2026_matteo_kitti_picks';
const RESULTS_TABLE = 'oscars_2026_matteo_kitti_results';

const defaultHeaders = {
    apikey: SUPABASE_PUBLISHABLE_KEY,
    Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
    'Content-Type': 'application/json',
};

const toQueryString = (params) => new URLSearchParams(params).toString();

export const fetchOscars2026Picks = async () => {
    const query = toQueryString({
        select: '*',
        order: 'category_order.asc',
    });

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${PICKS_TABLE}?${query}`, {
        method: 'GET',
        headers: defaultHeaders,
    });

    if (!response.ok) {
        throw new Error('Unable to load Oscars picks from Supabase.');
    }

    return response.json();
};

export const saveOscars2026Pick = async (payload) => {
    const response = await fetch(
        `${SUPABASE_URL}/rest/v1/${PICKS_TABLE}?on_conflict=user_slug,category_slug`,
        {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                Prefer: 'resolution=merge-duplicates,return=representation',
            },
            body: JSON.stringify(payload),
        }
    );

    if (!response.ok) {
        throw new Error('Unable to save your pick.');
    }

    const rows = await response.json();
    return rows[0];
};

export const fetchOscars2026Results = async () => {
    const query = toQueryString({
        select: '*',
    });

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${RESULTS_TABLE}?${query}`, {
        method: 'GET',
        headers: defaultHeaders,
    });

    if (!response.ok) {
        const errorText = await response.text();

        if (
            errorText.includes(RESULTS_TABLE) &&
            (errorText.includes('does not exist') || errorText.includes('Could not find the table'))
        ) {
            return [];
        }

        throw new Error('Unable to load actual winners.');
    }

    return response.json();
};

export const saveOscars2026Result = async (payload) => {
    const response = await fetch(
        `${SUPABASE_URL}/rest/v1/${RESULTS_TABLE}?on_conflict=category_slug`,
        {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                Prefer: 'resolution=merge-duplicates,return=representation',
            },
            body: JSON.stringify(payload),
        }
    );

    if (!response.ok) {
        const errorText = await response.text();

        if (
            errorText.includes(RESULTS_TABLE) &&
            (errorText.includes('does not exist') || errorText.includes('Could not find the table'))
        ) {
            throw new Error(`To save actual winners, first run the updated SQL in Supabase to create ${RESULTS_TABLE}.`);
        }

        throw new Error('Unable to save the actual winner.');
    }

    const rows = await response.json();
    return rows[0];
};
